import script from "./page-title.vue?vue&type=script&lang=js"
export * from "./page-title.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__